import Modal from 'react-modal';

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  children: React.ReactNode;
}

const modalStyles = {
	overlay: {
		backgroundColor: 'rgba(95, 136, 175, .5)',
		zIndex: 999999,
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		backgroundColor: '#fff',
		borderRadius: '.5rem',
		border: 'none',
	},
};

export const CustomModal = ({ modalIsOpen, setIsOpen, children }: ModalProps) => {
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={() => setIsOpen(false)}
      style={modalStyles}
    >
      {children}
    </Modal>
  )
}